import { modelsImpl } from '@optionway/models';
import type { BookingStatus, BookingStatusEnum, BookingStatusResult } from '@optionway/models';

interface BookingStatusStore {
  recordId?: number;
  result?: BookingStatusResult;
  email?: string;
}

export const useBookingStatusStore = defineStore('booking-status', {
  state: (): BookingStatusStore => ({
    recordId: undefined,
    result: undefined,
    email: undefined,
  }),
  getters: {
    status(): BookingStatus | undefined {
      return this.result?.status;
    },
  },
  actions: {
    saveRecordId(recordId: number) {
      this.recordId = recordId;
    },
    saveEmail(email: string) {
      this.email = email;
    },
    saveResult(result: BookingStatusResult) {
      this.result = result;
    },
    saveError(status: BookingStatusEnum) {
      const result = new modelsImpl.BookingStatusResultImpl();
      result.status = status;
      result.recordId = this.recordId ?? 0;
      this.result = result;
    },
  },
});
